import { render } from "./WellInfoTab.vue?vue&type=template&id=f2926c6a&scoped=true"
import script from "./WellInfoTab.vue?vue&type=script&lang=js"
export * from "./WellInfoTab.vue?vue&type=script&lang=js"

import "./WellInfoTab.vue?vue&type=style&index=0&id=f2926c6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2926c6a"]])

export default __exports__